var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v(_vm._s(_vm.title))])], 1)], 1)])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2 justify-content-between"
  }, [_c('div', {
    staticClass: "col-12 col-xl-8 mb-2 mb-xl-0 d-flex justify-content-between"
  }, [_c('h4', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.title))])]), _c('div', {
    staticClass: "col-12 col-xl-8 mt-3"
  }, [_c('h6', [_vm._v("上下班設定")]), _c('b-form-radio-group', {
    attrs: {
      "options": _vm.officeDutyOptions
    },
    model: {
      value: _vm.extra.office_duty,
      callback: function callback($$v) {
        _vm.$set(_vm.extra, "office_duty", $$v);
      },
      expression: "extra.office_duty"
    }
  }), _c('h6', {
    staticClass: "mt-3"
  }, [_vm._v("請假設定")]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "啟用請假提醒"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "value": _vm.officeLeaveCheckValeu
    },
    model: {
      value: _vm.extra.office_leave,
      callback: function callback($$v) {
        _vm.$set(_vm.extra, "office_leave", $$v);
      },
      expression: "extra.office_leave"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "請假起始時間"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-xl-4"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "Select Date",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "disabled": !_vm.isLeave
    },
    model: {
      value: _vm.office_leave_start.date,
      callback: function callback($$v) {
        _vm.$set(_vm.office_leave_start, "date", $$v);
      },
      expression: "office_leave_start.date"
    }
  })], 1), _c('div', {
    staticClass: "col-12 col-xl-4"
  }, [_c('vue-timepicker', {
    attrs: {
      "format": "HH:mm",
      "input-class": ['form-control'],
      "disabled": !_vm.isLeave
    },
    model: {
      value: _vm.office_leave_start.time,
      callback: function callback($$v) {
        _vm.$set(_vm.office_leave_start, "time", $$v);
      },
      expression: "office_leave_start.time"
    }
  })], 1)])]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "請假結束時間"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-xl-4"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "Select Date",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "disabled": !_vm.isLeave
    },
    model: {
      value: _vm.office_leave_end.date,
      callback: function callback($$v) {
        _vm.$set(_vm.office_leave_end, "date", $$v);
      },
      expression: "office_leave_end.date"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.office_leave_start.date.beforeEndAt.$invalid
    }
  }, [_vm._v(" 結束時間必須大於起始時間 ")])], 1), _c('div', {
    staticClass: "col-12 col-xl-4"
  }, [_c('vue-timepicker', {
    attrs: {
      "format": "HH:mm",
      "input-class": ['form-control'],
      "disabled": !_vm.isLeave
    },
    model: {
      value: _vm.office_leave_end.time,
      callback: function callback($$v) {
        _vm.$set(_vm.office_leave_end, "time", $$v);
      },
      expression: "office_leave_end.time"
    }
  })], 1)])])], 1)]), _c('div', {
    staticClass: "d-flex justify-content-center",
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.goBackByConfig
    }
  }, [_vm._v("返回 ")]), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("儲存")])], 1)])], 1)], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }